// extracted by mini-css-extract-plugin
export default {"list":"Dropdown_list__BR-U9","dropdownBtn":"Dropdown_dropdownBtn__3lCYS"};